import { TEAMS_COLLECTION, PLANS_COLLECTION } from '../../../constants'
import { FirestoreClient } from '../../../types'
import { FirestoreAdmin } from '../../../types/FirestoreAdmin'
import { Plan } from '../../../types/Plan'

interface Props<T extends FirestoreClient | FirestoreAdmin> {
  firestore: T
  teamId: string
}

export const getPlansRef = <T extends FirestoreClient | FirestoreAdmin>({
  firestore,
  teamId,
}: Props<T>): T extends FirestoreClient
  ? firebase.firestore.CollectionReference<Plan>
  : FirebaseFirestore.CollectionReference => {
  return firestore
    .collection(TEAMS_COLLECTION)
    .doc(teamId)
    .collection(PLANS_COLLECTION) as any
}
